<template>
    <v-chip
        size="x-small"
        label
        :class="getBadgeInfo(type, isProposed, proxyProductKey).background"
        style="padding-right: 0.6rem; padding-left: 0.6rem;"
    >
        <span class="badge-font" :class="getBadgeInfo(type, isProposed, proxyProductKey).textColor">
            {{ $t(`general.badge.${getBadgeInfo(type, isProposed, proxyProductKey).type}`) }}
        </span>
    </v-chip>
</template>

<script setup>
import { includes } from 'lodash';
import productBadgeType from '@enums/product-badge-type';

const { current, proposed, New, productGroup } = productBadgeType;

const badgeTypes = {
    productBadge: {
        background: 'product-badge',
        textColor: 'black--text',
    },
    newProductBadge: {
        background: 'new-product-badge',
        textColor: 'white--text',
    },
    proposedProductBadge: {
        background: 'proposed-product-badge',
        textColor: 'white--text',
    },
};

defineProps({
    type: {
        required: false,
        type: String,
    },
    isProposed: {
        required: false,
        type: Boolean,
    },
    proxyProductKey: {
        required: false,
        type: Number,
    },
});

const getBadgeInfo = (type, isProposed, proxyProductKey) => {
    const badgeType =
        type ||
        (() => {
            if (isProposed) return proposed;
            if (proxyProductKey) return New;

            return current;
        })();

    if (includes([current, productGroup], badgeType)) {
        return {
            type: badgeType,
            ...badgeTypes.productBadge,
        };
    }
    if (badgeType === proposed) {
        return {
            type: badgeType,
            ...badgeTypes.proposedProductBadge,
        };
    }
    return {
        type: badgeType,
        ...badgeTypes.newProductBadge,
    };
};
</script>

<style lang="scss" scoped>
.badge-font {
    font-size: 0.8rem;
    font-weight: 500;
}
</style>
